import React, { useContext } from "react";
import "./AboutUsHome.css";
import "./ResponsiveAbout.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { filterKey } from "../../helper/function";
import { dataContext } from "../../context/DataContextProviderr";

const AboutUsHome = () => {
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "aboutUs"
  );
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  return (
    <div className="about-home">
      <div className="top">
        <div className="image-section">
          <div className="text-logo">
            <p>{filterKey(filterAllWebParts, "aboutus-head-title1")?.map((item) => item.Value)}</p>
            <img src="/pic/logo.png" alt="logo" />
          </div>
          <div className="text">
            <p>{filterKey(filterAllWebParts, "aboutus-head-title2")?.map((item) => item.Value)}</p>
          </div>
        </div>
        <div className="brown-section"></div>
      </div>
      <div className="bottom">
        <div className="left">
          <div className="nescafe-section"></div>
          <img src={filterKey(filterAllWebParts, "aboutus-image-home")?.map((item) => item.Value)} alt="production line" />
        </div>
        <div className="right">
          <div className="text">
            <p>
            {filterKey(filterAllWebParts, "aboutus-head-description")?.map((item) => item.Value)}
            </p>
          </div>
          <div className="button-container">
            <Button onClick={()=> navigateHandler("/aboutUs")}>نمایش بیشتر</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsHome;
